export default ['50', '100', '200', '300', '400', '500', '1000'];
